import type { CommandBody } from '../CrossOriginMessage';

/**
 * Indicates that the user isn't authorized to perform the operation.
 */
export class UnauthorizedCommandBody implements CommandBody {}
